import { render, staticRenderFns } from "./sendLinkSuccess.vue?vue&type=template&id=4e3c89f6&scoped=true&"
import script from "./sendLinkSuccess.vue?vue&type=script&lang=js&"
export * from "./sendLinkSuccess.vue?vue&type=script&lang=js&"
import style0 from "./sendLinkSuccess.vue?vue&type=style&index=0&id=4e3c89f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3c89f6",
  null
  
)

export default component.exports